export default {
  getUsers: (state) => state.users?.data,
  getUsersPagination: (state) => state.users?.pagination,
};
